import { MenuItem, Select, type SelectProps } from '@mui/material';

type Props = SelectProps<string> & {
  options: readonly string[];
};

export function SelectField({ options, sx, ...props }: Props) {
  return (
    <Select {...props} sx={{ background: '#fff', ...sx }}>
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
}
